<div class="auth-code-page" authTheme>
    <div class="auth-code-container">
        <!-- Logo and Header -->
        <div class="text-center mb-4">
            <img [src]="logo" alt="ADN Logo" class="login-logo" />
            <h2 class="h3 mb-2">Reset Password</h2>
            <p class="text-muted">Choose where the password reset code gets sent to</p>
        </div>

        <div class="vstack gap-3">
            <div class="card">
                <button class="btn card-body sign-in-option"
                    (click)="goTo('sms')">
                    <i class="bi bi-phone"></i><span>Continue with text</span>
                </button>
            </div>
            <div class="card">
                <button class="btn card-body sign-in-option"
                    (click)="goTo('email')">
                    <i class="bi bi-envelope-fill"></i><span>Continue with email</span>
                </button>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
            <a routerLink="/login" class="btn btn-link p-0">
                <i class="bi bi-arrow-left"></i>Back to login
            </a>
        </div>
    </div>
</div>
